export const isNumeric = (str: string) => !Number.isNaN(+str);
